import React from 'react';
import PropTypes from 'prop-types';

const Alert = ({ title, color, icon, variant, content }) => {
    return (
        <div className={`new-alert ${color || 'info'} ${variant || 'standard'}`}>
            {icon}
            <div className="alert-content">
                {title && <h4>{title}</h4>}
                <span
                    dangerouslySetInnerHTML={{
                        __html: content
                    }}
                />
            </div>
        </div>
    );
};

Alert.propTypes = {
    title: PropTypes.string,
    color: PropTypes.string.isRequired,
    icon: PropTypes.node,
    variant: PropTypes.oneOf(['filled', 'outline', 'standard']),
    content: PropTypes.node.isRequired
};

export default Alert;
